import React from 'react';
import {
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogContentText as MuiDialogContentText,
  DialogActions as MuiDialogActions,
  Slide,
  Paper,
} from '@mui/material';
import Button from './ButtonBasic';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogBasic({
  /** Dialog Props */
  open = false, // bool
  BackdropComponent, // elementType
  classes, // object
  disableEscapeKeyDown = false, // bool
  fullScreen = false, // bool
  fullWidth = false, // bool
  maxWidth = 'sm', // 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
  PaperComponent = Paper, // elementType
  PaperProps, // object
  scroll = 'paper', // 'body' | 'paper'
  sx, // object
  TransitionComponent = Transition, // elementType
  TransitionProps, // object
  onBackdropClick = () => {},
  onClose = () => {},
  /** DialogTitle Props */
  title, // node
  titleClasses, // object
  titleSx, // object
  /** DialogContent Props */
  content, // node
  contentClasses, // object
  dividers = false, // bool
  contentSx, // object
  /** DialogContentText Props */
  contentText, // node
  contentTextClasses, // object
  contentTextSx, // object
  /** DialogActions Props */
  actions, // node
  actionsClasses, // object
  disableSpacing = false, // bool
  actionsSx, // object
  useCloseButton = true, // bool
  useSaveButton = false, // bool
  saveButtonName = '저장', // save button name
  onSave = () => {}, // dialog Save ACtion
  useSaveAfterClose = true, // click save button and after auto close.	"true" or "false"
  closeButtonName = 'Close',
}) {
  const CloseDialog = () => {
    onClose();
  };

  const BackdropClick = () => {
    onBackdropClick();
  };
  const SaveButton = () => {
    onSave();
    useSaveAfterClose && onClose();
  };
  return (
    <MuiDialog
      open={open}
      BackdropComponent={BackdropComponent}
      classes={classes}
      disableEscapeKeyDown={disableEscapeKeyDown}
      fullScreen={fullScreen}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      PaperComponent={PaperComponent}
      PaperProps={PaperProps}
      scroll={scroll}
      sx={sx}
      TransitionComponent={TransitionComponent}
      TransitionProps={TransitionProps}
      onBackdropClick={BackdropClick}
      onClose={CloseDialog}
      disableAutoFocus={true}
    >
      {title && (
        <MuiDialogTitle classes={titleClasses} sx={titleSx}>
          {title}
        </MuiDialogTitle>
      )}
      <MuiDialogContent
        classes={contentClasses}
        dividers={dividers}
        sx={{ p: 0, px: 1, ...contentSx }}
      >
        {content}
        <MuiDialogContentText classes={contentTextClasses} sx={contentTextSx}>
          {contentText}
        </MuiDialogContentText>
      </MuiDialogContent>
      <MuiDialogActions
        classes={actionsClasses}
        disableSpacing={disableSpacing}
        sx={actionsSx}
      >
        {actions}
        {useCloseButton && (
          <Button
            sx={{
              marginX: 0.5,
              width: '100%',
              borderRadius: 2,
              backgroundColor: '#E0EAE9',
              '&:hover': {
                backgroundColor: '#E0EAE9', // hover 시 배경색
              },
              color: '#00602E',
              fontSize: '15px',
              padding: '0px, 20px, 0px, 20px',
            }}
            size="medium"
            name={closeButtonName}
            onClick={CloseDialog}
          />
        )}
        {useSaveButton && (
          <Button
            sx={{
              marginX: 0.5,
              width: '100%',
              borderRadius: 2,
              backgroundColor: '#2CA900',
              '&:hover': {
                backgroundColor: '#2CA900', // hover 시 배경색
              },
              color: '#FFFFFF',
              //height: "5vh",
              fontSize: '15px',
              padding: '0px, 20px, 0px, 20px',
            }}
            size="medium"
            name={saveButtonName}
            onClick={SaveButton}
          ></Button>
        )}
      </MuiDialogActions>
    </MuiDialog>
  );
}

export default React.memo(DialogBasic);
